module.exports = __webpack_public_path__ + "img/news-04.cd7f8571.jpg";